import { render, staticRenderFns } from "./customerPortrayal.vue?vue&type=template&id=4c1a8202&scoped=true"
import script from "./customerPortrayal.vue?vue&type=script&lang=js"
export * from "./customerPortrayal.vue?vue&type=script&lang=js"
import style0 from "./customerPortrayal.vue?vue&type=style&index=0&id=4c1a8202&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1a8202",
  null
  
)

export default component.exports